import { render, staticRenderFns } from "./OrganisationMembers.vue?vue&type=template&id=0b944585&scoped=true"
import script from "./OrganisationMembers.vue?vue&type=script&lang=js"
export * from "./OrganisationMembers.vue?vue&type=script&lang=js"
import style0 from "./OrganisationMembers.vue?vue&type=style&index=0&id=0b944585&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b944585",
  null
  
)

export default component.exports